/**
 * 组图发布（预览图）
 * */
import React, { Component } from "react";
import { Upload, Icon } from "antd";
// import "./UploadPreviewImage.scss";
import UploadWall from "../../../../../../components/upload/UploadWall";
import {message } from "../../../../../sysManagement/utils/sysManagementUtils";
import {PIC_TYPE_ORIGINAL, PIC_TYPE} from '../../../../../../constants/index' ;

class UploadPreviewImage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    render() {
        const { value } = this.props;
        const accept = PIC_TYPE_ORIGINAL.map(item => "." + item).join(',');
        return (
            <div className="upload-wrap">
                <UploadWall
                    accept={accept}
                    name="file"
                    action="/dynamic/storage/uploadFile"
                    onChange={this.handleChange}
                    beforeUpload={this.handleBeforeUpload}
                    style={{
                        width:"130px",
                        height:"130px",
                        overflow:"hidden",
                        padding:"0",
                        backgroundColor:'rgba(0, 80, 179, 0.04)'
                    }}
                    imageUrl={value}
                />
                <div style={{position:'relative',top:90,left:16}}>
                    <div onClick={()=>{this.props.onChange("")}} style={{color:"#0050B3",fontSize:"12px",cursor:"pointer",}}>删除</div>
                    <div>
                        支持bmp、jpg、png等常见图片格式文件上传，图片最大限制不超过20M
                    </div>
                </div>
            </div>
        );
    }

    //上传前添加上传提示，限制非格式的上传
    handleBeforeUpload = (file, fileList) => {
        // const upload = file.type === "application/zip" ? true : false;
        let fileName = file.name.split('.');
        let upload = fileName.at(-1).toLowerCase();
        upload = PIC_TYPE.includes(upload);
        if(!upload){
            message.error('暂不支持该文件类型!');
        }
        return new Promise((resolve, reject) => {
            if (!upload) {
                reject(file);
            } else {
                resolve(file);
            }
        });
    }

    handleChange = info => {
        if (info.file.status === "uploading") {
            this.setState({ loading: true });
            return;
        }
        if (info.file.status === "done") {
            this.props.onChange(info.file.response.data.path);
            this.setState({
                loading: false,
            });
            message.success("图片上传成功！");
        }
    };
}


export default UploadPreviewImage;